<template>
    <div class="details-container">
      <div class="details-header">
          <div class="details-header-title">
            感谢您关注起亚品牌，以下是更多相关信息：
          </div>
      </div> 
      <div class="details-grid-wrapper">
        <!-- 上方卡片 -->
        <div class="details-buttons-container">
          <!-- 背景图 -->
          <img class="details-bg-image" src="/assets/~/media/images/ai/bg-service.png" alt="">
          <div class="details-content">
            <div class="service-info">
                <div class="service-info-left">
                    <div class="service-title">欢迎了解起亚暖心服务</div>
                    <div class="service-subtitle">为您构建 ​从购车到拥车的无忧旅程</div>
                </div>
            </div>
            <!-- 按钮 -->
           <div class="details-buttons">
            <div class="details-button" v-for="item in buttons" :key="item.text" @click="handleButtonClick(item)">
              {{ item.text }}
            </div>
           </div>
          </div>
          
        </div>

        <!-- 机器人说话图标 -->
        <div class="robot-talking-container">
          <img class="robot-wholebody" src="/assets/~/media/images/ai/robot-wholebody.png" alt="">
          <div class="robot-talking-text-box">
            <div class="robot-talking-text">起亚已为您检索到官网所有服务相关</div>
            <div class="robot-talking-text">信息请您浏览</div>
          </div>
        </div>
        
        <!-- 相关信息 -->
        <div class="details-bottom-container" v-if="announcementHasData">
          <DetailList 
            title="相关信息"
            questionType="8"
            :list="announcementData"
            :default-items="5"
            @more-click="onMoreClick"
          />
        </div>
        <!-- 所有都没数据占位 -->
        <div v-else class="no-data-placeholder">
          <img src="/assets/~/media/images/ai/no-inf.png" alt="暂无图片" class="no-data-image" />
          <p class="no-data-text">暂无内容</p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { aiUrl } from "@/config/base";
  import DetailList from './detail-parts/DetailList.vue';
  export default {
    name: 'details',
    props: {
      question: {
        type: String,
        default: ''
      }
    },
    components: {
      DetailList,
    },
    data() {
      return {       
        buttons: [
          {
            text: "我的起亚",
            link: "https://www.kia.cn/owners/"
          },
          {
            text: "起亚服务",
            link: "https://www.kia.cn/owners/KiaService"
          },
          {
            text: "预约服务 ",
            link: "https://www.kia.cn/owners/KiaSubscribe"
          },
          {
            text: "用户指南 ",
            link: "https://www.kia.cn/owners/UserGuide"
          },
          {
            text: "备件精品",
            link: "https://www.kia.cn/owners/SuppliesAndGoods"
          },
          {
            text: "起亚智能互联",
            link: "https://www.kia.cn/owners/KiaConnect"
          },
          {
            text: "EV体验",
            link: "https://www.kia.cn/owners/EV"
          },
        ],
        announcementData: [],// 相关信息
        announcementHasData: false, // 相关信息是否有数据
        token: '',
        // 分页相关数据
        currentPage: 1,
        pageSize: 10,
        totalCount: 0,
        loading: false,
        currentQuestion: '', // 当前搜索的问题
      }
    },
    computed: { 
        
    },
    created() {
      const userInfo = localStorage.getItem('user');
      var token=''
      if(userInfo){
        this.userInfo = JSON.parse(userInfo)
        token = this.userInfo.token
      }
      this.token = token
    },
    mounted() {
      
      //暂时
      // this.handleQuestionChange("");
    },
    watch: {
      question: {
        handler(newQuestion) {
          if (newQuestion) {
            console.log('Details组件接收到问题参数:', newQuestion);
            // 这里可以根据问题参数来更新组件内容
            this.handleQuestionChange(newQuestion);
          }
        },
        immediate: true
      }
    },
    methods: {
        onMoreClick(type) {
          // 传递分页数据给父组件
          this.$emit('more-click', {
            type: type,
            data: this.announcementData,
            total: this.totalCount,
            pageSize: this.pageSize
          });
        },
        handleQuestionChange(question) {
          this.currentQuestion = question;
          this.getAnnouncement(question);
        },
        //获取相关信息数据
        async getAnnouncement(question, page = 1) {
          const that = this;
          console.log('获取数据:', { question, page, pageSize: this.pageSize });
          this.loading = true;
          this.$axios
            .post(
              `${aiUrl}keyword/searchOwnerService`,
              `pageNum=1&pageSize=100&question=${question}`,
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
              }
            )
            .then((res) => {
              const response = res.data || res;
              console.log('API响应:', response);
              console.log('请求参数:', { pageNum: page, pageSize: this.pageSize });
              if (response.code == 200) {
                that.announcementData = response.rows || [];
                that.totalCount = response.total || 0;
                
                console.log('更新后的数据:', {
                  announcementData: that.announcementData,
                  totalCount: that.totalCount
                });
                
                //判断是否有没有数据
                if(that.announcementData && that.announcementData.length > 0){
                  that.announcementHasData = true;
                }else{
                  that.announcementHasData = false;
                }
                // 将相关信息数据上报给父组件（用于传递给 MoreStripe）
                // try {
                //   that.$emit('announcement-data', that.announcementData);
                // } catch (e) {}
              } else {
                console.log('API返回错误:', response);
              }
            })
            .catch((error) => {
              console.error('获取相关信息失败:', error);
              that.announcementHasData = false;
            })
            .finally(() => {
              that.loading = false;
            })
        },
        
        handleButtonClick(item) {
            _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''),  'question-8-服务-点击头部卡片： '+ item.text, 1]);
            stm_clicki("send",'event',window.location.href, "点击", 'question-8-服务-点击头部卡片： '+ item.text);
            console.log('点击按钮，跳转到:', item.link)
            // 这里可以添加跳转逻辑
            if (item.link) {
            window.open(item.link, '_blank')
            }
        },
      
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .details-container {
      width: 100%;
      height: 100%;
      //   padding: calc(20 / 1080 * 100vh) calc(20 / 1920 * 100vw);
      background-color: rgba(6, 20, 31, 1);
    }
    
    .details-header {
    // height: calc(80 / 1920 * 100vw);
    height: 57px;
    display: flex;
    align-items: center; 
    justify-content: space-between;
    padding: 0 calc(35 / 1920 * 100vw);
    background-color: rgba(6, 20, 31, 1);
    .details-header-title {
      // font-size: calc(16 / 1920 * 100vw);
      font-size: 12px;
      color: rgba(155, 161, 165, 1);
      font-family: 'FZLanTingHeiS-R-GB'; 
    }
   }
   .details-grid-wrapper {
    padding: calc(20 / 1920 * 100vw) calc(20 / 1920 * 100vw);
    border-radius: calc(12 / 1920 * 100vw) calc(12 / 1920 * 100vw) 0 0;
     overflow: auto;
     background-color: #fff;
    //  height: calc(100% -  80 / 1920 * 100vw);
    height: calc(100% -  57px);
     /* 自定义滚动条样式 */
    &::-webkit-scrollbar {
      width: 4px;
    }
    
    &::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.05);
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 3px; 
      transition: background 0.3s ease;
      
      &:hover {
        background: rgba(0, 0, 0, 0.4);
      }
    }
    
    /* Firefox 滚动条样式 */
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);

   }
   
   .details-buttons-container {
     position: relative;
     width: 100%;
      //  aspect-ratio: 1249 / 188;
      // aspect-ratio: 1249 / 409;
     border-radius: calc(12 / 1920 * 100vw);
     overflow: hidden;
     margin-bottom: calc(24 / 1920 * 100vw);
     background: linear-gradient(270deg, rgba(167, 150, 124, 0) 19.46%, #A49582 41.57%);

     .details-bg-image {
       position: absolute;
       height: 100%;
       top: 0;
       bottom: 0;
       right: 0;
       z-index: 1;
     }
     
     .details-content {
       position: relative;
       z-index: 2;
       
       padding:30px;
       .service-info {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 30px 0 50px 0;
            .service-info-left{
                color: #fff;
                .service-title {
                    font-size: 20px;
                    font-family: 'FZLanTingHeiS-DB-GB';
                }
                .service-subtitle {
                    font-size: 14px;
                    font-family: 'FZLanTingHeiS-R-GB';
                    display: flex;
                }
            }
        }
     }
     
     
     .details-buttons {
        position:relative;
        z-index: 10;
        display: flex;
        gap: calc(10 / 1920 * 100vw);
        .details-button {
            max-width: 158px;
            max-height: 129px;
            width: calc(173.8 / 1920 * 100vw);
            height: calc(141.9 / 1920 * 100vw);
            background-color: #fff;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            //font-size: 14px;
            font-size: min(14px, calc(16 / 1920 * 100vw));
            font-family: 'FZLanTingHeiS-B-GB';
            color: #fff;
            border: 1px solid rgba(211, 211, 211, 1);
            background: rgba(144, 129, 110, 0.5);
            backdrop-filter: blur(30px)

        }
        .details-button:hover {
            background: rgba(255, 255, 255, 0.8);
            backdrop-filter: blur(30px);
            color: #000;
        }

     }
     
   }
   

   .robot-talking-container {
    display: flex;
    align-items: start;
    justify-content: start;
    gap: calc(10 / 1920 * 100vw);
    .robot-wholebody {
      width: calc(72 / 1920 * 100vw);
      height: calc(101 / 1920 * 100vw);
    }
    .robot-talking-text-box {
      padding-left: calc(20 / 1920 * 100vw);
      width: calc(327 / 1920 * 100vw);
      height: calc(64 / 1920 * 100vw);
      display: flex;
      flex-direction: column;
      align-items: start;
      justify-content: center;
      border: 1px dashed rgba(219, 219, 219, 1);
      border-radius: calc(20 / 1920 * 100vw);
      background-color: rgba(243, 243, 243, 1);
    }
    .robot-talking-text {
      font-size: calc(16 / 1920 * 100vw);
      font-family: 'FZLanTingHeiS-DB-GB';
      line-height: 1.1;
    }
   }
   
  

  .details-bottom-container {
    border: 1px solid rgba(205, 208, 210, 1);
    border-radius: calc(12 / 1920 * 100vw);
    padding: calc(20 / 1920 * 100vw) calc(20 / 1920 * 100vw);
    background-color: rgba(249, 250, 251, 1);
    margin-top: calc(-20 / 1920 * 100vw);
    // margin-bottom: calc(40 / 1920 * 100vw);
    position: relative;
    z-index: 10;
  }

  
  .no-data-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  aspect-ratio: 1279 / 342;
  margin-top: calc(-20 / 1920 * 100vw);
  position: relative;
  z-index: 10;
  background-color: rgba(249, 250, 251, 1);
  border-radius: calc(12 / 1920 * 100vw);
  border: 1px solid rgba(205, 208, 210, 1);
}

.no-data-image {
  width: calc(64 / 1920 * 100vw);
  height: calc(54 / 1920 * 100vw);
  margin-bottom: calc(8 / 1920 * 100vw);
  opacity: 0.5;
}

.no-data-text {
  color: rgba(186, 192, 196, 1);
  font-size: calc(12 / 1920 * 100vw);
  font-family: 'FZLanTingHeiS-R-GB';
  margin: 0;
}
  
  
  </style>
  